
import React from 'react';
import {connect} from 'react-redux';
import { Formik, Field } from 'formik';
import * as yup from 'yup';
import { Form, Row, Col, Collapse, Card} from 'react-bootstrap';
import Stats from '../Stats';
import BasicInfo from './BasicInfo';
import { RadioButton, RadioButtonGroup } from '../Common';
import moment from 'moment';

const schema = yup.object().shape({
    isMarried: yup.string().required('Please select whether you are single or married'),
    client: yup.object().when('isMarried', {
        is: 'false',
        then: yup.object().shape({
            firstName: yup.string().required('Please enter your first name '),
            lastName: yup.string().required('Please enter your last name'),
            birthdate: yup.string().required('Please enter your birthdate')
        }),
        otherwise: yup.object().shape({
            firstName: yup.string().required('Please enter your first name '),
            lastName: yup.string().required('Please enter your last name'),
            birthdate: yup.string().required('Please enter your birthdate')
        })
    }),
    state: yup.string().required('Please select your state of residence'),
    spouse: yup.object().when('isMarried', {
        is: 'true',
        then: yup.object().shape({
            firstName: yup.string().required('Please enter spouse first name '),
            lastName: yup.string().required('Please enter spouse last name') ,
            birthdate: yup.string().required('Please enter spouse birthdate')
        })
    })
  });
// const initialValues = {
//     client: {
//     },
//     spouse: {
//     }
//   };
  class Step1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lastName:''
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setLastName = this.setLastName.bind(this);
    }
    setLastName (name){
        this.setState({lastName:name});
    }
  handleSubmit(values,actions) {
      let form = this.props.form;
    // actions.setSubmitting(false);
    // console.log('---here are values',values);
    values = {
        firstName: values.client.firstName,
        lastName: values.client.lastName,
        state: values.state,
        birthdate: new Date(values.client.birthdate),
        isMarried: values.isMarried,
        spouse: {
            firstName: values.spouse.firstName,
            lastName: values.spouse.lastName,
            birthdate: new Date(values.spouse.birthdate)
        }
    };
    if(form && form.client && form.client.isMarried !== values.isMarried){
        this.props.upliftState(values,'client');
        // this.props.setWizardValue(values,'client',this.props.currentStep, this.props.stepsOpened);
        this.props.nextStep('continue');
    }
    else{
        // this.props.setWizardValue(values,'client',this.props.currentStep, this.props.stepsOpened);
        this.props.upliftState(values,'client');
        this.props.nextStep();
    }
    return;
  }
   
  render() {
    return(
        
                <Formik
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={this.props}
                    validationSchema={schema}
                    onSubmit={this.handleSubmit}
                >
                {({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        setFieldValue,
                        setFieldTouched,
                        values,
                        errors,
                        touched,
                        isSubmitting
                    }) => (
                        <Form onSubmit={handleSubmit} >
                           <Card className="stepChild">
                            <Card.Header>
                                <Row >
                                    <span style={{'position':'absolute','paddingLeft':'15px'}}><strong>1.</strong></span>
                                    <Col md={"10"} sm={"12"} style={{'paddingLeft':'35px'}}> 
                                        {this.props.getStepHeader(1) } 
                                    </Col>
                                    <Col md={"2"} sm={"12"}>
                                        <Stats type='edit' step={1} {...this.props} />
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Collapse in={this.props.isActive}>
                            <Card.Body>
                       <Form.Row>
                            <Form.Group as={Col} controlId="validationFormikIsMarried">
                            <RadioButtonGroup
                                id="radioGroup"
                                label=""
                                value={values.isMarried}
                                error={errors.isMarried}
                                touched={setFieldTouched}
                                isValid={touched.isMarried && !errors.isMarried}
                                isInvalid={errors.isMarried}
                            >
                                <Field
                                component={RadioButton}
                                name="isMarried"
                                id="notMarried"
                                expect={'false'}
                                label="Single"
                                checked={(values.isMarried === 'false' ? true:false)}
                                onChange={e => {setFieldValue('isMarried',e.target.value);
                                setFieldTouched('isMarried',true);}}
                                />
                                <Field
                                component={RadioButton}
                                name="isMarried"
                                id="married"
                                expect={'true'}
                                label="Married"
                                checked={(values.isMarried === 'true' ? true:false)}
                                onChange={e => {setFieldValue('isMarried',e.target.value);
                                setFieldTouched('isMarried',true);}}
                                />
                                <Form.Control.Feedback type="invalid">
                                   {errors.isMarried}
                                </Form.Control.Feedback> 
                            </RadioButtonGroup>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            
                            { (values.isMarried === 'true' || values.isMarried === 'false') &&
                            <Form.Group as={Col} md="12" >
                                <Card>
                                    <Card.Header>Your Information</Card.Header>
                                    <Card.Body>
                                        <Field
                                            component={BasicInfo} 
                                            handleSubmit={handleSubmit} 
                                            handleChange={handleChange} 
                                            handleBlur={handleBlur}
                                            setFieldValue={setFieldValue}
                                            setFieldTouched={setFieldTouched}
                                            values={values}
                                            errors={errors }
                                            touched={touched}
                                            isSubmitting={isSubmitting} 
                                            setLastName={this.setLastName}
                                            stepsOpened={this.props.stepsOpened}
                                            type="client" 
                                        />
                                    </Card.Body>
                                </Card>
                                </Form.Group>
                                }
                                {values.isMarried === 'true' &&
                                <Form.Group as={Col} md="12" >
                                
                                    <Card>
                                        <Card.Header>Spouse Information</Card.Header>
                                        <Card.Body>
                                        
                                            <Field
                                                component={BasicInfo} 
                                                handleSubmit={handleSubmit} 
                                                handleChange={handleChange} 
                                                handleBlur={handleBlur}
                                                setFieldValue={setFieldValue}
                                                setFieldTouched={setFieldTouched}
                                                values={values}
                                                errors={errors }
                                                touched={touched}
                                                isSubmitting={isSubmitting} 
                                                lastName={this.state.lastName}
                                                setLastName={this.setLastName}
                                                stepsOpened={this.props.stepsOpened}
                                                type="spouse" 
                                            />
                                        </Card.Body>
                                    </Card>
                                </Form.Group>
                                }
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} md="6" controlId="validationFormikState">
                                <Form.Label className="required">State of Residence</Form.Label>
                                <Form.Control name="state" as="select"
                                value={values.state}
                                onChange={handleChange}
                                // isValid={touched.state && !errors.state}
                                isInvalid={errors.state}
                                >
                                    <option value="">Please Select</option>
                                    <option value="AL">Alabama</option>
                                    <option value="AK">Alaska</option>
                                    <option value="AZ">Arizona</option>
                                    <option value="AR">Arkansas</option>
                                    <option value="CA">California</option>
                                    <option value="CO">Colorado</option>
                                    <option value="CT">Connecticut</option>
                                    <option value="DE">Delaware</option>
                                    <option value="DC">District of Columbia</option>
                                    <option value="FL">Florida</option>
                                    <option value="GA">Georgia</option>
                                    <option value="HI">Hawaii</option>
                                    <option value="ID">Idaho</option>
                                    <option value="IL">Illinois</option>
                                    <option value="IN">Indiana</option>
                                    <option value="IA">Iowa</option>
                                    <option value="KS">Kansas</option>
                                    <option value="KY">Kentucky</option>
                                    <option value="LA">Louisiana</option>
                                    <option value="ME">Maine</option>
                                    <option value="MD">Maryland</option>
                                    <option value="MA">Massachusetts</option>
                                    <option value="MI">Michigan</option>
                                    <option value="MN">Minnesota</option>
                                    <option value="MS">Mississippi</option>
                                    <option value="MO">Missouri</option>
                                    <option value="MT">Montana</option>
                                    <option value="NE">Nebraska</option>
                                    <option value="NV">Nevada</option>
                                    <option value="NH">New Hampshire</option>
                                    <option value="NJ">New Jersey</option>
                                    <option value="NM">New Mexico</option>
                                    <option value="NY">New York</option>
                                    <option value="NC">North Carolina</option>
                                    <option value="ND">North Dakota</option>
                                    <option value="OH">Ohio</option>
                                    <option value="OK">Oklahoma</option>
                                    <option value="OR">Oregon</option>
                                    <option value="PA">Pennsylvania</option>
                                    <option value="RI">Rhode Island</option>
                                    <option value="SC">South Carolina</option>
                                    <option value="SD">South Dakota</option>
                                    <option value="TN">Tennessee</option>
                                    <option value="TX">Texas</option>
                                    <option value="UT">Utah</option>
                                    <option value="VT">Vermont</option>
                                    <option value="VA">Virginia</option>
                                    <option value="WA">Washington</option>
                                    <option value="WV">West Virginia</option>
                                    <option value="WI">Wisconsin</option>
                                    <option value="WY">Wyoming</option>
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">{errors.state}</Form.Control.Feedback>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} md="12" style={{"padding":"0px","margin":"0px"}} controlId="step1Continue">
                                <Col md={"12"} sm={"12"}>
                                    <Stats type='continue' step={1} {...this.props} />
                                </Col>
                            </Form.Group>
                        </Form.Row>
                        </Card.Body>
                        </Collapse>
                        </Card>
                    </Form>
                    )}
                </Formik>
               
    );
   }
}
const mapStateToProps = (state , ownProps) => {
    let {form} = state.mainState;
        let client = form.client;
        if(!client.isMarried || client.isMarried === 'false'){
            client.spouse = {};
        }
        return {
            form,
            isMarried:client.isMarried,
            state:client.state,
            client:{
                isMarried:client.isMarried,
                firstName:client.firstName,
                lastName: client.lastName,
                birthdate: client.birthdate ? moment(client.birthdate).format('MM/DD/YYYY'):'',
            },
            spouse:{
                firstName:client.spouse.firstName,
                lastName: client.spouse.lastName ? client.spouse.lastName: client.lastName,
                birthdate: client.spouse.birthdate ? moment(client.spouse.birthdate).format('MM/DD/YYYY'):'',
            },
            ...ownProps
        }
  }
  export default connect(
    mapStateToProps,
   null
  )(Step1)